import React from "react";
import { connect } from "react-redux";
import "./Checkbox.scss";
import { useIntl } from "react-intl";

const Checkbox = React.forwardRef((props, ref) => {
	const { formatMessage } = useIntl();

	return (
		<div className={`${props.className ? props.className : ""} flex direction-row align-items-center`}>
			<input
				type="checkbox"
				name="checkbox"
				className={`checkbox ${props.state ? props.state : ""}`}
				ref={ref}
				onChange={(e) => {
					props.onChange(e);
				}}
				checked={ref && ref.current ? ref.current.checked : false}
			/>
			{props.label && (
				<div className="text text-body--4 text-left ml-8">{formatMessage({ id: `${props.label}` })}</div>
			)}
			{props.isMandatory ? <span className="input-mandatory-sign ml-8">*</span> : <></>}
		</div>
	);
});

export default Checkbox;
